import { FC } from 'react'

type Props = {
  state: boolean
  setState: (value: React.SetStateAction<boolean>) => void
  label: string
  id: string
}

const CheckBox: FC<Props> = (props) => {
  const { state, setState, label, id } = props
  return (
    <span className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id={id}
        checked={state}
        onChange={() => setState((prev) => !prev)}
      />
      <label htmlFor={id} className="form-check-label text-small">
        {label}
      </label>
    </span>
  )
}

export default CheckBox
